
export const testimonialsTranslations = {
  testimonialsTitle: {
    fr: "Ce qu'en disent nos membres",
    en: "What our members say"
  },
  testimonial1: {
    fr: "Grâce à Leaders, j'ai trouvé les investisseurs pour mon projet en Algérie. Un réseau d'une qualité exceptionnelle.",
    en: "Thanks to Leaders, I found investors for my project in Algeria. A network of exceptional quality."
  },
  testimonial2: {
    fr: "Leaders m'a permis de rencontrer la diaspora algérienne qui compte. Les opportunités d'affaires sont concrètes et immédiates.",
    en: "Leaders allowed me to meet the Algerian diaspora that matters. Business opportunities are concrete and immediate."
  },
  testimonial3: {
    fr: "Une plateforme où la force collective algérienne se révèle. Chaque rencontre à Alger est une source d'inspiration et d'opportunités.",
    en: "A platform where Algerian collective strength reveals itself. Every meeting in Algiers is a source of inspiration and opportunities."
  },
};
